import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addAndApplyFilter, removeAndApplyFilter } from '../../../actions/filterActions';

// components
import { SbSharedRefineMenuInputCheckbox } from '../SbSharedRefineMenuInput/SbSharedRefineMenuInputCheckbox';

class SbSharedRefineMenuMultiSelectComponent extends React.Component {
    constructor() {
        super();
        this.onChange = this.onChange.bind(this);
    }

    onChange(checked, urlLabel) {
        return checked ? this.props.onSelect(urlLabel) : this.props.onDeselect(urlLabel);
    }

    render() {
        const { appliedFilterValues, valuesToShow } = this.props;

        return (
            <div>
                {valuesToShow.map((item, index) => {
                    const isChecked = appliedFilterValues.some(
                        appliedValue => appliedValue.urlLabel === item.urlLabel
                    );
                    return (
                        <SbSharedRefineMenuInputCheckbox
                            key={`${item.urlLabel}-${index}`}
                            value={item.urlLabel}
                            checked={isChecked}
                            seoLink={item.link}
                            onChange={checked => {
                                this.onChange(checked, item);
                            }}
                            text={item.displayName}
                            count={item.count}
                            isHidden={item.isHidden}
                        />
                    );
                })}
            </div>
        );
    }
}

SbSharedRefineMenuMultiSelectComponent.propTypes = {
    appliedFilterValues: PropTypes.array.isRequired,
    valuesToShow: PropTypes.array.isRequired,
    onDeselect: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch, props) {
    return {
        onSelect(changedValue) {
            dispatch(addAndApplyFilter(props.filterName, changedValue));
        },
        onDeselect(changedValue) {
            dispatch(removeAndApplyFilter(props.filterName, changedValue));
        },
    };
}

export const SbSharedRefineMenuMultiSelect = connect(
    null,
    mapDispatchToProps
)(SbSharedRefineMenuMultiSelectComponent);
